import { Home } from "../pages/home";
import { Tax } from "@/pages/tax";
export var Routes = {
    "/solicitacao-criada": Tax,
    "/": Home,
};
